// extracted by mini-css-extract-plugin
module.exports = {"chestInventory":"_5da0cef","message":"_28e7ce4"};